import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const monthlyCalculationRoutes = [
  {
    path: routes.monthlyCalculation.earningVariables,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/earningVariables"
    ),
  },
  {
    path: routes.monthlyCalculation.deductionVariable,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/deductionVariables"
    ),
  },
  {
    path: routes.monthlyCalculation.IncrementArrear,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/incrementArrear"
    ),
  },

  {
    path: `${routes.monthlyCalculation.IncrementArrearAdd}/:employeeId/:rowId`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/incrementArrearAdd"
    ),
  },
  {
    path: `${routes.monthlyCalculation.IncrementArrearList}/:id`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/incrementArrearList"
    ),
  },
  {
    path: `${routes.monthlyCalculation.IncrementArrearEdit}/:id`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/incrementArrearEdit"
    ),
  },
];
